import inViewport from "@/directives/inViewport";

export default [
  inViewport,
];
